// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.axis {
    --vis-axis-tick-label-cursor: pointer;
    --vis-axis-tick-label-text-decoration: underline;
    --vis-axis-tick-label-color: #366ACE;
}
`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/axis/single-axis/style.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gDAAgD;IAChD,oCAAoC;AACxC","sourcesContent":[".axis {\n    --vis-axis-tick-label-cursor: pointer;\n    --vis-axis-tick-label-text-decoration: underline;\n    --vis-axis-tick-label-color: #366ACE;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"axis": `axis`
};
export default ___CSS_LOADER_EXPORT___;
